<template>
  <div>
    <ViewHeader
      :account-id="accountId"
      :project-id="projectId"
      @created="handleEmailCampaignCreated"
    />
    <div class="p-8">
      <div class="max-w-7xl mx-auto">
        <EmailCampaignList :key="lastRefreshedAt" :account-id="accountId" :project-id="projectId" />
      </div>
    </div>
  </div>
</template>

<script>
import ViewHeader from './components/ViewHeader.vue';
import EmailCampaignList from './components/EmailCampaignList.vue';
import middleware from '@/routes/guards';

export default {
  components: {
    ViewHeader,
    EmailCampaignList,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      lastRefreshedAt: new Date().getTime(),
    };
  },
  beforeRouteEnter: middleware('account-permission:read email campaigns'),
  methods: {
    handleEmailCampaignCreated() {
      this.lastRefreshedAt = new Date().getTime();
    },
  },
};
</script>
